import { ApplicationTypes, Hole, attachComponent } from 'metalworks-domain'

import {
  htmlHotspotComponent,
  sceneEntityPropertiesComponent,
  selectableComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { AnchorPointHotspot } from '../ui/AnchorPointHotspot'
import { MeasurementToolHotspot } from '../ui/MeasurementToolHotspot'

export const anchorPointComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(sceneEntityPropertiesComponent, 'main')
    .withEntity('AnchorPoint')
    .withFilter(s => s.$visible)
    .attach(s => ({
      offsetX: s.$absCoords3D.x - (Hole.is(s.$shape) ? s.$shape.$absCoords3D.x : 0),
      offsetY: s.$absCoords3D.y - (Hole.is(s.$shape) ? s.$shape.$absCoords3D.y : 0),
      offsetZ: s.$absCoords3D.z - (Hole.is(s.$shape) ? s.$shape.$absCoords3D.z : 0),
    })),
  // TODO: it is no longer needed
  attachComponent
    .withComponent(selectableComponent, 'default')
    .withEntity('AnchorPoint')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    .attach(() => ({})),
  attachComponent
    .withComponent(htmlHotspotComponent, 'select')
    .withEntity('AnchorPoint')
    // TODO: memoEval
    .attach(s => ({
      offsetX: 0,
      offsetY: 0,
      // TODO (Bending): Offset from the plate?
      // offsetZ: (state.entities.find(entity => entity.id === state.rootEntityId) as Plate).thickness + 1,
      offsetZ: 0,
      unit: 'mm',
      node: <AnchorPointHotspot id={s.id} />,
      disableOcclude: true,
    })),
  attachComponent
    .withComponent(htmlHotspotComponent, 'measure')
    .withEntity('AnchorPoint')
    // TODO: memoEval
    .attach(s => ({
      offsetX: 0,
      offsetY: 0,
      // TODO (Bending): Offset from the plate?
      // offsetZ: (state.entities.find(entity => entity.id === state.rootEntityId) as Plate).thickness + 1,
      offsetZ: 0,
      unit: 'mm',
      node: <MeasurementToolHotspot id={s.id} />,
      disableOcclude: true,
    })),
]
